import declare from "dojo/_base/declare";
import UniversalDate from "csi/heading/UniversalDate";
import types from "csi/types";

const EFFECTIVE_END = "EffectiveEnd";

const ECEffectiveDateRenderer = declare(UniversalDate, {
	/**
	 * @override
	 * set the min and max date constraints for the DatePicker
	 */
	_addDynamicParams: function(ctx, h, params) {
		this.inherited(arguments);
		if (h.m_id == EFFECTIVE_END) {
			var startDate = ctx.getNode().EffectiveStart;
			if (startDate) {
				params.constraints.min = types.getTimeDate(startDate + 24*60*60);
			} else {
				delete params.constraints.min;
			}
			delete params.constraints.max;
		} else {
			var endDate = ctx.getNode().EffectiveEnd;
			if (endDate) {
				params.constraints.max = types.getTimeDate(endDate);
			} else {
				delete params.constraints.max;
			}
			delete params.constraints.min;
		}
	},
});

export = ECEffectiveDateRenderer;
